import styled from "styled-components";

export const Container = styled.div`
  max-width: 100%;
  margin: 0 auto;
  background: url(./images/xpander-desktop.jpg);
  background-size: cover;
  height: 100vh;

  @media (min-width: ${({ theme }) => theme.mobile}) and (max-width: ${({
      theme,
    }) => theme.tablet}) {
    background-position-x: -600px;
  }

  @media (max-width: ${({ theme }) => theme.mobile}) {
    padding: 0;
    background: url(./images/xpander-mobile.jpg);
    background-position-x: -100px;
  }
`;
